// extracted by mini-css-extract-plugin
module.exports = {"headerBlockLogos":"headerBlockLogos_headerBlockLogos__33KPG","logo":"headerBlockLogos_logo__BM_bT"};